import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AuthentificationService} from "../services/authentification.service";

@Component({
    selector: 'njoy-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements OnInit {

    constructor(private router: Router, private authenService: AuthentificationService) {
        setTimeout(() => {
            if (this.authenService.isConnected()) {
                this.setIsAdminValueAndRedirect(this.authenService.isAdmin());
            } else {
                window.location.href = '/login';
            }
        }, 2000);

    }

    ngOnInit() {
    }

    private setIsAdminValueAndRedirect(isAdmin: boolean) {
        this.authenService.setIsAdmin(isAdmin);
        this.router.navigateByUrl('/dashboard');
    }
}
